import ChooseClientPage from "../pages/ChooseClientPage";
import CataloguePage from "../pages/AppNavigation";
import PLVPage from "../pages/PLVPage";
import FinishOrderPage from "../pages/FinishOrderPage";
import ViewCartPage from "../components/Carts/ViewCartPage/ViewCartPage";
import OrderAndInvoicePage from "../pages/OrderAndInvoicePage";
import UserList from "../pages/userList/userList";

export const admin = {
  NEW_CART: {
    path: "/orders/clients",
    private: true,
    role: "VRP",
    component: ChooseClientPage,
  },
  PLV_PAGE: {
    path: "/orders/complete",
    private: true,
    component: PLVPage,
  },
  FINISH_ORDER: {
    path: "/orders/finish",
    private: true,
    component: FinishOrderPage,
  },
  APP_NAVIGATION: {
    path: "/orders/:critere",
    private: true,
    component: CataloguePage,
  },
  VIEW_CART: {
    path: "/view-cart",
    private: true,
    component: ViewCartPage,
  },
  ORDER_AND_INVOICE: {
    path: "/order-and-invoice",
    private: true,
    component: OrderAndInvoicePage,
  },
  USER_LIST: {
    path: "/user-list",
    private: true,
    component: UserList,
  },
};
